import styled from 'styled-components'

const Wrap = styled.div.withConfig({
  shouldForwardProp: prop => !['detail'].includes(prop),
})`
  width: 100%;

  @media (min-width: 415px) {
    padding: 15px 15px 30px;
  }

  @media (min-width: 728px) {
    padding: 20px 20px 40px;
  }

  @media (min-width: 1024px) {
    padding: 30px 30px 50px;
  }
`
const PageWrapper = ({ children, detail }) => {
  return (
    <Wrap id="pageWrapper" detail={detail}>
      {children}
    </Wrap>
  )
}

PageWrapper.defaultProps = {
  detail: false,
}

export default PageWrapper
